import { useState } from 'react';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      return;
    }

    try {
      formData.delete('phone_alt');
      const response = await fetch('https://readdy.ai/api/form/d9u43cdca23r0tr1aq30', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们将定期为您推送最新赛事资讯。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败';
        if (serverMsg.toLowerCase().includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('订阅失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    }
  };

  return (
    <div id="newsletter" className="bg-background-50 rounded-2xl border border-background-200/60 p-8">
      <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2">
        订阅每日大赛资讯
      </h3>
      <p className="text-sm text-foreground-500 mb-6">
        第一时间获取最新赛事动态、优惠活动和独家内容
      </p>
      <form onSubmit={handleSubmit} data-readdy-form="" className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-xl border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            className="px-6 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            订阅
          </button>
        </div>
        <input
          type="text"
          name="phone_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="form-honeypot"
        />
        {status === 'success' && (
          <p className="text-sm text-accent-700 flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line"></i>
            {message}
          </p>
        )}
        {status === 'error' && (
          <p className="text-sm text-red-600 flex items-center gap-1.5">
            <i className="ri-error-warning-line"></i>
            {message}
          </p>
        )}
      </form>
    </div>
  );
}